import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
// 修改 原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path:'/',
      redirect:{name:'login'},
    },
    {
      path: '/login',
      name: 'login',
      component:resolve => require(['@/view/login'], resolve),
    },
    {
      path: '/register',
      name: 'register',
      component:resolve => require(['@/view/register'], resolve),
    },
    {
      path: '/MemberShip',
      name: 'MemberShip',
      component:resolve => require(['@/view/MemberShip'], resolve),
    },
    {
      path: '/Company',
      name: 'Company',
      component:resolve => require(['@/view/Company'], resolve),
    },
    {
      path: '/personal',
      name: 'personal',
      component:resolve => require(['@/view/personal'], resolve),
    },
    {
      path: '/information',
      name: 'information',
      component:resolve => require(['@/view/information'], resolve),
    },
    {
      path: '/JobHunting',
      name: 'JobHunting',
      component:resolve => require(['@/view/JobHunting'], resolve),
    },
    {
      path: '/Notice',
      name: 'Notice',
      component:resolve => require(['@/view/Notice'], resolve),
    },
    {
      path: '/NoticeContent',
      name: 'NoticeContent',
      component:resolve => require(['@/view/NoticeContent'], resolve),
    },
    {
      path: '/Statement',
      name: 'Statement',
      component:resolve => require(['@/view/Statement'], resolve),
    },
    {
      path: '/rhxz',
      name: 'rhxz',
      component:resolve => require(['@/view/rhxz'], resolve),
    },
    {
      path: '/bill',
      name: 'bill',
      component:resolve => require(['@/view/bill'], resolve),
    },
    {
      path: '/list',
      name: 'list',
      component:resolve => require(['@/view/list'], resolve),
    },
    {
      path: '/Content',
      name: 'Content',
      component: resolve => require(['@/view/audit/Content'], resolve),
      redirect: { name: 'UnderReview' },
      children:[
        {
          path: '/Pay',
          name: 'Pay',
          component:resolve => require(['@/view/audit/Pay'], resolve),
        },
        {
          path: '/Member',
          name: 'Member',
          component:resolve => require(['@/view/audit/Member'], resolve),
        },
      ]
    },
    // 手机端
    {
      path: '/home',
      name: 'home',
      component: resolve => require(['@/view/mobile/home'], resolve),
    },
    {
      path: '/MobileMemberShip',
      name: 'MobileMemberShip',
      component:resolve => require(['@/view/mobile/MobileMemberShip'], resolve),
    },
    {
      path: '/MobileCompany',
      name: 'MobileCompany',
      component:resolve => require(['@/view/mobile/MobileCompany'], resolve),
    },
    {
      path: '/MobileRegister',
      name: 'MobileRegister',
      component:resolve => require(['@/view/mobile/MobileRegister'], resolve),
    },
    {
      path: '/MobilePay',
      name: 'MobilePay',
      component:resolve => require(['@/view/mobile/MobilePay'], resolve),
    },
    {
      path: '/MobileMember',
      name: 'MobileMember',
      component:resolve => require(['@/view/mobile/MobileMember'], resolve),
    },
    {
      path: '/MobilePersonal',
      name: 'MobilePersonal',
      component:resolve => require(['@/view/homepage/MobilePersonal'], resolve),
    },
    {
      path: '/MobileInformation',
      name: 'MobileInformation',
      component:resolve => require(['@/view/homepage/MobileInformation'], resolve),
    },
    {
      path: '/MobileJobHunting',
      name: 'MobileJobHunting',
      component:resolve => require(['@/view/homepage/MobileJobHunting'], resolve),
    },
    {
      path: '/MobileNotice',
      name: 'MobileNotice',
      component:resolve => require(['@/view/homepage/MobileNotice'], resolve),
    },
    {
      path: '/MobileNoticeContent',
      name: 'MobileNoticeContent',
      component:resolve => require(['@/view/homepage/MobileNoticeContent'], resolve),
    },
    {
      path: '/MobileBill',
      name: 'MobileBill',
      component:resolve => require(['@/view/homepage/MobileBill'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js